import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EncodeHelper } from '../../../helpers/encode.helper';
import { GetDashboardPastDueRequest } from '../../../interfaces/getDashboardPastDueRequest';
import { GeneralReportDTO, GetOrdersListResponse, OrderDTO } from '../../../interfaces/models';
import { OrderAndTrip } from '../../../interfaces/orderAndTripDTO';
import { PathService } from '../../../providers/path/path.service';
import { ReportsUiService } from '../../../providers/reports/reports.ui.service';

@Injectable({ providedIn: 'root' })
export class DashboardHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly pathService: PathService,
    private readonly reportsUiService: ReportsUiService,
  ) {}

  getToPickedUpTodayOrders(): Observable<GetOrdersListResponse<OrderAndTrip>> {
    return this.httpClient.get<GetOrdersListResponse<OrderAndTrip>>(
      this.pathService.getPath('/dashboard/me/to-picked-up-today'),
    );
  }

  getToDeliverTodayOrders(): Observable<GetOrdersListResponse<OrderAndTrip>> {
    return this.httpClient.get<GetOrdersListResponse<OrderAndTrip>>(
      this.pathService.getPath('/dashboard/me/to-delivery-today'),
    );
  }

  getPastDueOrders(filter: GetDashboardPastDueRequest): Observable<GetOrdersListResponse<OrderDTO>> {
    return this.httpClient.get<GetOrdersListResponse<OrderDTO>>(
      this.pathService.getPath(`/dashboard/me/past-due?${EncodeHelper.encodeData(filter)}`),
    );
  }

  getPieStats() {
    return this.httpClient.get<GeneralReportDTO>(
      this.pathService.getPath('/dashboard/me/pie-stats'),
    ).pipe(map(response => this.reportsUiService.getFormattedReports(response)))
  }
}
